<template>
  <div id="home">
    <h1>THE CANOE SPEAKS</h1>
    <div class="content-wrapper">
      <div class="textbox">
        <span class="animated zoomInBig custom-slow">Auf den Wiesen</span>
        <span class="animated zoomInBig delay-2s custom-slow">In den Wäldern</span>
        <span class="animated zoomInBig delay-4s custom-slow">Am Gipfel</span>
        <span class="animated zoomInBig delay-6s custom-slow">Im Fluss</span>
        <span class="animated zoomInBig delay-8s custom-slow">Am Rande</span>
        <span class="animated zoomInBig delay-10s custom-slow">In der Falte</span>
        <span class="animated zoomInBig delay-12s custom-slow">Aussen</span>
        <span class="animated zoomInBig delay-14s custom-slow">Innen</span>
        <span class="animated zoomInBig delay-16s custom-slow">Farbe ist überall</span>
      </div>
      <v-image-slider :images="images"></v-image-slider>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Home',
  data () {
    return {
      images: [
        require('@/assets/img/home_1.jpg'),
        require('@/assets/img/home_2.jpg'),
        require('@/assets/img/home_3.jpg')
      ]
    }
  }
}
</script>

<style lang='scss' scoped>
#home {
  .zoomInBig {
    animation: zoomInBig;
    animation-fill-mode: forwards;
  }
  @keyframes zoomInBig {
    0% {
      opacity: 0;
      transform: scale3d(2, 2, 2);
    }
    100% {
      opacity: 1;
    }
  }
  .delay-2s {
    animation-delay: 2s;
  }
  .delay-4s {
    animation-delay: 4s;
  }
  .delay-6s {
    animation-delay: 6s;
  }
  .delay-8s {
    animation-delay: 8s;
  }
  .delay-10s {
    animation-delay: 10s;
  }
  .delay-12s {
    animation-delay: 12s;
  }
  .delay-14s {
    animation-delay: 14s;
  }
  .delay-16s {
    animation-delay: 16s;
  }
  .custom-slow {
    animation-duration: 4s;
  }
  .content-wrapper {
    display: flex;
  }
  .textbox {
    font-size: 1.5em;
    margin: 0 100px;
    display: flex;
    flex-flow: column;
    align-items: center;
    justify-content: center;
    span {
      opacity: 0;
      white-space: nowrap;
    }
  }
}
@media screen and (max-width: 860px) {
  .content-wrapper {
    flex-flow: column;
    .imageBox {
      margin: 50px 0;
    }
  }
}
</style>
